import { Box } from "@mui/material";
import HeaderPhoto from "../../assets/images/research_page.jpg";
import PageHeader from "../../components/PageHeader";
import LichenFloraSection from "./LichenFloraSection";
import BeeSection from "./BeeSection";
import OverviewSection from "./OverviewSection";
import CompletedSection from "./CompletedSection";

function Research() {
  return (
    <Box>
      <PageHeader image={HeaderPhoto} title="Research" />

      <OverviewSection />
      <LichenFloraSection />
      <BeeSection />
      <CompletedSection />
    </Box>
  );
}

export default Research;
